

































import { Vue, Component, Prop } from "vue-property-decorator";

import { Entity } from "@/types";
import Tooltip from "@/components/Tooltip.vue";

@Component({ components: { Tooltip } })
export default class BaseNote extends Vue {
  singular = {
    chapters: "chapter",
    sections: "section",
    codes: "code"
  };

  @Prop({ type: String })
  private title!: string;

  @Prop({ type: String })
  private attribute!: string;

  @Prop({ type: Object })
  private entity!: Entity<any>;
}
